<template>
  <v-row>
    <v-col cols="3">
      <v-sheet class="pt-4" color="transparent"><!-- style="position:sticky; top:100px" -->
        <v-card width="180px" outlined>
          <v-card-text>
            <v-responsive class="align-center text-center" :aspect-ratio="1/1">
              <img :src="require(`@/assets/appAsset-brand--${activeBiller.brand}.svg`)" :alt="activeBiller.name" width="90%">
            </v-responsive>
          </v-card-text>
        </v-card>
        <v-list class="pl-0" color="transparent">
          <v-list-item class="pl-0">
            <v-list-item-content class="d-block text--secondary font-weight-medium">Compatibilidad</v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Países</v-list-item-title>
              <v-list-item-subtitle class="d-block pt-1 caption text--primary">
                <img class="mr-2" v-for="d in activeBiller.countries" :key="d" :src="require(`@/assets/appAsset-flag--${d}.svg`)" :alt="activeBiller.name" height="16px">
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Tipos de facturas</v-list-item-title>
              <v-list-item-subtitle class="pt-1">
                <span class="d-block mb-1 caption text--primary" v-for="d in activeBiller.invoiceTypes" :key="d">{{d}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0" v-if="activeBiller.otherTypes && activeBiller.otherTypes.length">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Otros tipos de documentos</v-list-item-title>
              <v-list-item-subtitle class="pt-1">
                <span class="d-block mb-1 caption text--primary" v-for="d in activeBiller.otherTypes" :key="d">{{d}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-col>

    <v-col cols="9">
      <v-row>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="ml-n1 subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{name: 'Integrations'}" class="subtitle-1 routerLink font-weight-medium">Integraciones</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>{{activeBiller.name}}
          </v-toolbar-title>
        </v-toolbar>
      </v-row>
      <v-row no-gutters>
        <v-col md="3">
          <span class="d-block caption">Documentación</span>
          <v-btn :href="`${$DOCS_BASE}${activeBiller.docs}`" target="_blank" color="primary" text :ripple="false">Ir a la documentación<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-col>
        <v-divider vertical />
        <v-col md="3" class="ml-2">
          <span class="d-block caption">Sitio web</span>
          <v-btn :href="activeBiller.website" target="_blank" color="primary" text :ripple="false">Visitar el sitio<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card>
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Información de la integración</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0">
              <span v-if="!installed" class="d-block pt-6 px-5 background text--primary">Obtén las credenciales de acceso, <span class="text--secondary font-weight-medium">Organization Secret Key</span> y <span class="text--secondary font-weight-medium">User Secret Key</span>, desde tu cuenta de Facturapi.</span>

              <v-list v-if="!installed" class="py-3" color="background" dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Secret Key Organización</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-text-field v-model="$v.billerConnection.api_key.$model" :error="$v.billerConnection.api_key.$error" background-color="white" outlined required single-line dense maxlength="254" :disabled="installed" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Secret Key Usuario</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-text-field v-model="$v.billerConnection.extra_data.user_sk.$model" background-color="white" dense :error="$v.billerConnection.extra_data.user_sk.$error" hide-details outlined required single-line />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <template v-if="installed">
                <v-list class="py-3 v-sm-text-fields" color="background">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium overflow-visible">Nombre de la organización</v-list-item-title>
                      <v-list-item-subtitle class="ml-1 text--primary subtitle-1 font-weight-regular">
                        {{billerConnection.extra_data.organization_name}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium overflow-visible">Nombre legal</v-list-item-title>
                      <v-list-item-subtitle class="ml-1 text--primary subtitle-1 font-weight-regular">
                        {{billerConnection.extra_data.organization_legal_name}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>

              <v-list class="py-3 v-sm-text-fields" color="background">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium overflow-visible">
                      RFC Organización
                      <v-chip v-if="!installed" class="ml-1 mt-n1" color="secondary" x-small>Opcional</v-chip>
                    </v-list-item-title>
                    <v-list-item-subtitle class="ml-1 my-1 body-2 text--primary font-weight-regular">
                      <template v-if="installed">RFC de la empresa registrado en Facturapi.</template>
                      <template v-else>Es necesario solo si tienes acceso a más de una empresa en Facturapi.</template>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-text-field v-model="$v.billerConnection.extra_data.organization_rfc.$model" background-color="white" dense :error="$v.billerConnection.extra_data.organization_rfc.$error" hide-details maxlength="24" outlined :placeholder="installed ? 'Sin especificar' : 'Escribe el RFC de la organización...'" :disabled="installed" single-line />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn v-if="installed" @click="destroyBillerConnection" dark color="red">Desconectar integración</v-btn>
              <v-btn v-else @click="createBillerConnection" :loading="loaderConnect" color="primary">Conectar</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'
import { maxLength, required } from 'vuelidate/lib/validators'

import GenericViewMixin from '@/mixins/GenericViewMixin'

import billers from '../../../collections/billers'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    billers: billers,
    billerConnection: {
      biller: 'facturapi',
      api_key: '',
      extra_data: {
        organization_rfc: null,
        user_sk: null
      }
    },
    installed: false,
    loaderConnect: false
  }),
  computed: {
    ...mapState({
      instance: state => state.billers.billerconnectionsDetail
    }),
    activeBiller () {
      return this.billers.find(b => b.id === 'facturapi')
    }
  },
  created () {
    this.retrieveBillerConnection()
  },
  methods: {
    createBillerConnection () {
      this.$v.billerConnection.$touch()

      if (this.$v.billerConnection.$invalid) {
        return false
      }

      this.loaderConnect = true

      this.$store.dispatch('billers/CREATE', {
        resource: 'billerconnections',
        payload: this.billerConnection
      })
      .then((response) => {
        this.billerConnection = Object.assign(this.billerConnection, response.data)
        this.$dialog.message.info(`Se ha integrado ${this.activeBiller.name}.`)
        this.installed = true
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loaderConnect = false
      })
    },
    destroyBillerConnection () {
      this.$dialog.warning({
        title: `Desconectar ${this.activeBiller.name}`,
        text: `
          <span class="d-block mb-4">¿Estás seguro de desconectar este proveedor de facturación?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer.</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('billers/DESTROY', {
                resource: 'billerconnections',
                id: 'facturapi'
              })
              .then(() => {
                this.$dialog.message.info(`Se ha eliminado la integración con Facturapi.`)

                this.retrieveBillerConnection()

                // reset billerConnection
                this.billerConnection = {
                  biller: 'facturapi',
                  api_key: '',
                  extra_data: {
                    organization_rfc: null,
                    user_sk: null
                  }
                }
                this.$v.$reset()
              })
              .catch((error) => {
                this.$dialog.message.warning(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    retrieveBillerConnection () {
      this.$store.dispatch('billers/RETRIEVE', {
        resource: 'billerconnections',
        id: 'facturapi'
      })
      .then(() => {
        this.installed = true
        this.billerConnection = cloneDeep(this.instance)
      })
      .catch(() => {
        this.installed = false
      })
    }
  },
  validations: {
    billerConnection: {
      api_key: {
        maxLength: maxLength(64),
        required
      },
      extra_data: {
        user_sk: {
          required
        },
        organization_rfc: {
          maxLength: maxLength(12)
        }
      }
    }
  }
}
</script>